import React, { Component } from 'react';

class GoodSkinFeel extends Component {
	render() {
		return (
			<section className="assessment bg ingredients good__skin">
				<div className="container-fluid">
					<h1 className="assessment__heading">What will good skin make you feel?</h1>
					<div className="name__age--badges">
						<span>Confident in my skin</span>
						<span>I can be myself</span>
						<span>Make-up will be a choice!</span>
						<span>One less thing to worry</span>
					</div>
				</div>
			</section>
		);
	}
}


export default GoodSkinFeel;